import { useEffect } from "react";
import { Button, Flex, Typography } from "antd";
import { useSearchParams } from "react-router-dom";
import "./project.docstore.scss";
import { DocstoreSection } from "./docstore-section";
import { DocstoreSections } from "./docstore-sections";

export function ProjectDocstore() {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (!searchParams.get("documentType")) {
      setSearchParams((prevParams) => {
        const newParams = new URLSearchParams(prevParams);
        newParams.set("documentType", "PERMITS");
        return newParams;
      });
    }
  }, [searchParams, setSearchParams]);

  return (
    <Flex vertical className="page">
      <Flex justify="space-between" align="center" className="page-header">
        <Typography.Title level={3}>Документарий</Typography.Title>
        <Flex gap="middle">
          <Button>Поставить штамп</Button>
          <Button type="primary">Подписать штампы (32)</Button>
        </Flex>
      </Flex>

      <Flex vertical gap="middle">
        <DocstoreSections />
        <DocstoreSection />
      </Flex>
    </Flex>
  );
}
